<template>
  <div class="page_top page_bg">
    <div class="page_text_protocol" style="font-size: 12px;">
      <div class="ys">
        <h3 class="ql-align-center">
          <span>《隐私权保护政策》</span>
        </h3>
        <p class="ql-align-justify">
          <span>尊敬的用户，欢迎您下载、安装、注册、登录、使用（以下统称“使用”）无悠网络。无悠网络是由吉林省无悠网络科技有限公司（以下简称无悠网络）所拥有及运营的棋牌游戏平台。我们将按照《隐私权保护政策》（以下统称“本《隐私政策》”）收集、保存、使用、共享、披露及保护您的个人信息，因此请您务必在使用无悠网络之前，认真完整地阅读并理解、同意本《隐私政策》的所有条款。</span>
        </p>
        <h3>
          <strong>目录</strong>
        </h3>
        <p class="ql-align-justify">
          <span>一、阅读提示</span>
        </p>
        <p class="ql-align-justify">
          <span>二、引言</span>
        </p>
        <p class="ql-align-justify">
          <span>三、正文</span>
        </p>
        <p class="ql-align-justify">
          <span>（一）我们收集和使用您的个人信息类型和目的</span>
        </p>
        <p class="ql-align-justify">
          <span>（二）我们如何保存您的个人信息</span>
        </p>
        <p class="ql-align-justify">
          <span>（三）我们如何共享、转让、公开披露您的个人信息</span>
        </p>
        <p class="ql-align-justify">
          <span>（四）我们如何保护您的个人信息</span>
        </p>
        <p class="ql-align-justify">
          <span>（五）我们如何使用您的个人信息</span>
        </p>
        <p class="ql-align-justify">
          <span>（六）您的权利</span>
        </p>
        <p class="ql-align-justify">
          <span>（七）我们如何保护未成年人的个人信息</span>
        </p>
        <p class="ql-align-justify">
          <span>（八）本《隐私政策》如何更新</span>
        </p>
        <p class="ql-align-justify">
          <span>（九）如何联系我们</span>
        </p>
        <h3>
          <strong>一、阅读提示</strong>
        </h3>
        <p class="ql-align-justify">
          <span>（一）通过阅读本《隐私政策》，您将了解到：</span>
        </p>
        <p class="ql-align-justify">
          <span>“我们”是谁，如何联系我们，无悠网络有哪些业务功能；您在使用无悠网络期间，我们收集的您的个人信息类型和目的，您拒绝提供个人信息的后果；您的个人信息保存地点和期限；我们如何共享、披露、转让您的个人信息；采取了哪些措施来保护您个人信息的安全；您如何查询、更正、删除个人信息，撤回授权，注销账号，管理定向推送；如何投诉或提交建议；本《隐私政策》如何更新。</span>
        </p>
        <p class="ql-align-justify">
          <span>（二）阅读本《隐私政策》时，请您特别关注：</span>
        </p>
        <p class="ql-align-justify">
          <span>1、使用加粗与斜体相结合显著标识的内容，表示这些属于您的个人敏感信息。（是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。包括手机号码、身份证件号码、财产信息、交易信息等。）</span>
        </p>
        <p class="ql-align-justify">
          <span style="color: rgb(56, 56, 56);">2、使用加粗与下划线相结合显著标识的内容，表示这些内容需要您特别关注或重点注意。</span>
        </p>
        <h3>
          <strong>二、引言</strong>
        </h3>
        <p class="ql-align-justify">
          <span>（一）本《隐私政策》中的“我们”是指无悠网络的运营者，基本情况如下：</span>
        </p>
        <p class="ql-align-justify">
          <span>公司名称：吉林省无悠网络科技有限公司；</span>
        </p>
        <p class="ql-align-justify">
          <span>通讯地址：长春市净月开发区君盈身份广场1号楼411室；</span>
        </p>
        <p class="ql-align-justify">
          <span>联系方式：jilinwuyou_fuwu@163.com。</span>
        </p>
        <p class="ql-align-justify">
          <span>（二）本《隐私政策》的适用范围</span>
        </p>
        <p class="ql-align-justify">
          <span style="color: rgb(56, 56, 56);">本《隐私政策》适用于您通过无悠网络产品的网页、移动端（手机）等方式来访问和使用我们的产品/服务。</span>
        </p>
        <p class="ql-align-justify">
          <strong>
            <u>特别提醒您的是：</u>
          </strong>
        </p>
        <p class="ql-align-justify">
          <span>您具体获得的无悠网络产品/服务内容可能因为不同的产品类型、软件版本、手机操作系统而有所差异，如果在部分版本中不涵盖某些服务或未提供某些功能的，本《隐私政策》中涉及到上述服务/功能及相关个人信息的内容将不适用。</span>
        </p>
        <p class="ql-align-justify">
          <strong>
            <u>（三）本《隐私政策》的效力</u>
          </strong>
        </p>
        <p class="ql-align-justify">
          <span>如果您在初始安装、首次使用或首次登录/注册账号时，勾选或点击“同意”本《隐私政策》的，代表您同意本《隐私政策》。但这并不代表我们会立即收集本《隐私政策》包含的所有个人信息，只有在您通过自主性行为开启、使用无悠网络某项功能时，我们才会按照本《隐私政策》收集、使用该功能对应的个人信息。</span>
        </p>
        <p class="ql-align-justify">
          <span>如果您未勾选或点击“同意”本《隐私政策》而继续使用无悠网络相关产品，视为您接受和认可我们按照本《隐私政策》对您的相关信息进行处理。</span>
        </p>
        <p class="ql-align-justify">
          <span>如果您不同意本《隐私政策》，请不要使用或停止使用无悠网络相关产品。</span>
        </p>
        <h3>
          <strong>三、正文</strong>
        </h3>
        <h4>
          <strong>（一）我们收集和使用您的个人信息类型和目的</strong>
        </h4>
        <p>
          <span>在您使用无悠网络服务的过程中，无悠网络会按照如下方式收集您在使用服务时主动提供的或因为使用服务而产生的信息，用以向您提供服务、优化我们的服务以及保障您的账户安全：</span>
        </p>
        <p>
          <span>1.1 如果您使用无悠网络软件功能，则需要注册/登录（登录即代表您注册成为无悠网络的用户）无悠网络，我们将根据您注册/登录的方式，收集以下个人信息：</span>
        </p>
        <p class="ql-align-justify">
          <strong>
            <em>手机号码和密码</em>
          </strong>
          <span
            style="color: rgb(56, 56, 56);"
          >，是您选择使用手机号码注册/激活账户时，主动向我们提供的个人信息。同时，我们将通过发送短信验证码的方式来验证您的身份是否有效。</span>
        </p>
        <p class="ql-align-justify">
          <strong>
            <em>第三方应用账号（微信）</em>
          </strong>
          <span
            style="color: rgb(56, 56, 56);"
          >和昵称、头像、性别等公开信息（请以授权登录界面显示的信息为准），是您选择使用第三方账号注册/登录，并授权无悠网络读取您在该第三方账号注册的上述信息。</span>
        </p>
        <p class="ql-align-justify">
          <span>如果您不提供这些信息，则您无法注册/登录无悠网络产品，且无法使用需注册/登录的功能，但不会影响您正常使用无需注册/登录的功能。</span>
        </p>
        <p>
          <span>1.2 为满足相关法律法规政策及相关主管部门的要求，无悠网络用户需进行实名认证以继续使用和享受无悠网络。我们会在获得您同意或您主动提供的情况下收集您的实名身份信息，包括：姓名和身份证号，对于此类敏感信息，无悠网络对您的这些隐私信息会加以最大程度的保护，拒绝提供实名身份信息可能会导致您无法登陆无悠网络或在使用无悠网络过程中受到相应限制。</span>
        </p>
        <p>
          <span>1.3 为保障您正常使用我们的服务，维护游戏基础功能的正常运行，优化游戏产品性能，提升您的游戏体验并保障您的账号安全，我们会收集您的设备ID、设备名称、设备类型和版本、系统版本、IP地址、网络类型等信息。</span>
        </p>
        <p>
          <span>1.4 当您使用无悠网络服务时，我们会收集您的游戏日志信息，例如登录日志、物品日志、游戏对局信息等，用于游戏运营统计分析、客服投诉处理及其他游戏安全分析。</span>
        </p>
        <p>
          <span>1.5 当您使用无悠网络产品的消费功能时，我们会收集您的充值记录、消费记录等信息，以便您查询您的交易记录，同时尽最大程度保护您的虚拟物品安全。收集上述信息为实现无悠网络产品的消费功能所必须，否则将无法完成交易。</span>
        </p>
        <p>
          <span>1.6 为保障您的游戏账号安全，营造公平、健康及安全的游戏环境，我们会收集您的游戏识别信息、硬件及操作系统信息、进程及游戏崩溃记录等信息，以用于打击破坏游戏公平环境或干扰、破坏游戏服务正常进行的行为（如用于检测盗版、扫描外挂、防止作弊等）。</span>
        </p>
        <p>
          <span>1.7 为了更方便向您推荐您熟悉的地方游戏玩法，在您授权同意后，我们会收集您的地理位置信息。地理位置信息属于敏感信息，拒绝提供该信息只会导致无法实现该功能，但不影响您正常使用无悠网络的其他功能。</span>
        </p>
        <p>
          <span>1.8 根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用您的相关个人信息无需征求您的授权同意：</span>
        </p>
        <p>
          <span>（1） 与国家安全、国防安全等国家利益直接相关的；与公共安全、公共卫生、公共知情等重大公共利益直接相关的；</span>
        </p>
        <p>
          <span>（2） 与犯罪侦查、起诉、审判和判决执行等直接相关的；</span>
        </p>
        <p>
          <span>（3） 出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；</span>
        </p>
        <p>
          <span>（4） 所收集的个人信息是您自行向社会公众公开的；</span>
        </p>
        <p>
          <span>（5） 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</span>
        </p>
        <p>
          <span>（6） 根据您要求签订和履行合同所必需的；</span>
        </p>
        <p>
          <span>（7） 用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</span>
        </p>
        <p>
          <span>（8） 为开展合法的新闻报道所必需的；</span>
        </p>
        <p>
          <span
            style="color: rgb(56, 56, 56);"
          >（9） 出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</span>
        </p>
        <p>
          <span>（10） 法律法规规定的其他情形。</span>
        </p>
        <p>
          <span>1.9 请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们会通过页面提示、交互流程、网站公告等方式另行向您说明信息收集的内容、范围和目的，以征得您的同意。</span>
        </p>
        <p>
          <span>目前，我们不会主动从公司外的第三方获取您的个人信息。如未来为业务发展需要从公司外的第三方间接获取您的个人信息，我们会在获取前向您明示您个人信息的来源、类型及使用范围，如无悠网络开展业务需进行的个人信息处理活动超出您原本向公司外的第三方提供个人信息时的授权同意范围，我们将在处理您的该等个人信息前，征得您的明示同意；此外，我们也将会严格遵守相关法律法规的规定，并要求该第三方保障其提供的信息的合法性。</span>
        </p>
        <p class="ql-align-justify">
          <span style="color: rgb(56, 56, 56);">我们会综合上述信息进行分析，用于向您展示、推荐或推送您可能感兴趣的信息：</span>
        </p>
        <p class="ql-align-justify">
          <strong>
            <u>请您理解并同意，如您的信息无法单独或结合其他信息识别到您的个人身份，其不属于法律意义上您的个人信息；只有当您的信息可以单独或结合其他信息识别到您的个人身份时，则在结合使用期间，将作为您的个人信息按照本《隐私政策》处理与保护。</u>
          </strong>
        </p>
        <p class="ql-align-justify">
          <br />
        </p>
        <h4>
          <strong>（二）我们如何保存您的个人信息</strong>
        </h4>
        <h6>
          <strong>1.1保存地域</strong>
        </h6>
        <p class="ql-align-justify">
          <span>我们依照法律法规的规定，将您的个人信息</span>会通过安全的方式存储
          <span
            style="color: rgb(56, 56, 56);"
          >于中华人民共和国境内。目前，我们不会将上述信息传输至境外，如果我们向境外传输，将会遵循相关法律法规的规定，向您告知出境的个人信息类型、目的、接收方、安全保障措施和安全风险，并单独征得您的授权同意。</span>
        </p>
        <h6>
          <strong>1.2保存期限和方式</strong>
        </h6>
        <p>
          <span>一般情况下，我们只会在为实现服务目的所必需的时间内或法律法规规定的条件下存储您的个人信息。包括本地存储（例如利用APP进行数据缓存）、数据库和服务器日志。</span>
        </p>
        <p>
          <span>·&nbsp;法律规定的最低存储期限，如《网络安全法》等规定的最低保存时间。</span>
        </p>
        <p>
          <span>·&nbsp;为提供无悠网络产品/服务之目的所必需的期限，如在您使用手机号码注册/登录后使用无悠网络相应的功能时，我们会在您提供且使用该功能期间，持续保存您的手机号码，以向您正常提供该功能。</span>
        </p>
        <p class="ql-align-justify">
          <span>超出上述个人信息保存期限后，我们会将您的个人信息删除或匿名化处理。</span>
        </p>
        <h4>
          <strong>（三）我们如何共享、转让、公开披露您的个人信息</strong>
        </h4>
        <h6>
          <strong style="color: rgb(56, 56, 56);">1.1共享</strong>
        </h6>
        <p class="ql-align-justify">
          <span>我们不会与第三方公司、组织和个人共享您的个人信息，但以下情况除外：</span>
        </p>
        <p class="ql-align-justify">
          <span>（1）您自行提出要求的。</span>
        </p>
        <p class="ql-align-justify">
          <span>（2）征得您明确同意的。</span>
        </p>
        <p class="ql-align-justify">
          <span>（3）根据法律、行政法规、部门规章等规定，或政府部门提出的强制性要求。</span>
        </p>
        <p class="ql-align-justify">
          <span>（4）无悠网络内部的必要共享。</span>
        </p>
        <p class="ql-align-justify">
          <span>我们只会共享必要的个人信息，且受本《隐私政策》中所声明目的的约束。如要改变个人信息的处理目的，将再次征求您的授权同意。</span>
        </p>
        <p>
          <span>·&nbsp;（5）与授权合作伙伴共享：仅为实现本《隐私政策》中声明的目的，我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。如果我们共享能够直接识别到您身份的个人信息（如手机号码、身份证号等），会再次征得您的同意。</span>
        </p>
        <h6>
          <strong>1.2转让</strong>
        </h6>
        <p class="ql-align-justify">
          <span>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</span>
        </p>
        <p class="ql-align-justify">
          <span>（1）征得您明确同意的；</span>
        </p>
        <p class="ql-align-justify">
          <span>（2）在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本《隐私政策》的约束，否则我们将要求该公司、组织重新向您征求授权同意。</span>
        </p>
        <h6>
          <strong>1.3公开披露</strong>
        </h6>
        <p class="ql-align-justify">
          <span>我们仅会在以下情况下，公开披露您的个人信息：</span>
        </p>
        <p class="ql-align-justify">
          <span>（1）征得您明确同意的；</span>
        </p>
        <p class="ql-align-justify">
          <span>（2）基于法律规定的披露：在法律、法规规定、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</span>
        </p>
        <h6>
          <strong>1.4征得同意的例外</strong>
        </h6>
        <p class="ql-align-justify">
          <strong>
            <u>请您充分知晓，以下情形中，共享、转让、公开披露您的个人信息的，无需事先征得您的授权同意：</u>
          </strong>
        </p>
        <p class="ql-align-justify">
          <span>（1）与国家安全、国防安全直接相关的；</span>
        </p>
        <p class="ql-align-justify">
          <span>（2）与公共安全、公共卫生、重大公共利益直接相关的；</span>
        </p>
        <p class="ql-align-justify">
          <span>（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</span>
        </p>
        <p class="ql-align-justify">
          <span style="color: rgb(56, 56, 56);">（4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span>
        </p>
        <p class="ql-align-justify">
          <span>（5）您自行向社会公众公开的个人信息；</span>
        </p>
        <p class="ql-align-justify">
          <span style="color: rgb(56, 56, 56);">（6）从合法公开披露的信息中收集的您的个人信息，如合法的新闻报道、政府信息公开等渠道。</span>
        </p>
        <h4>
          <strong>（四）我们如何保护您的个人信息</strong>
        </h4>
        <p class="ql-align-justify">
          <strong>1.1</strong>
          <span
            style="color: rgb(56, 56, 56);"
          >我们非常重视您个人信息的安全，已使用了以下符合业界标准的安全防护措施来保护您的个人信息，防止您的个人信息被不当使用或被未经授权的访问、公开披露、使用、修改、损坏、丢失或泄漏：</span>
        </p>
        <p class="ql-align-justify">
          <span>（1）我们采用业界领先的技术保护措施。我们使用的技术手段包括但不限于防火墙、加密（例如SSL）、去标识化或匿名化处理、访问控制措施等，执行多机房双重备份机制；使用受信赖的保护机制防止您的个人信息遭到恶意攻击。</span>
        </p>
        <p>
          <span>（2）我们还会不断加强安装在您设备端的软件的安全能力。例如，我们会在您的设备本地完成部分信息加密工作，以巩固安全传输；我们会了解您设备安装的应用信息和运行的进程信息，以预防病毒、木马等恶意程序。我们建立了保障个人信息安全专门的管理制度、流程和组织。例如，我们严格限制访问信息的人员范围和权限，要求他们遵守保密义务并进行审计，违反义务的人员会根据规定进行处罚。我们也会审查该管理制度、流程和组织，以防未经授权的人员擅自访问、使用或披露用户的信息。</span>
        </p>
        <p class="ql-align-justify">
          <span>（3）无悠网络已做了全面的安全防护措施并取得了ISO27001的信息安全管理认证，会及时防御并处置各类信息安全威胁，为您的个人信息安全提供保障。</span>
        </p>
        <p class="ql-align-justify">
          <span>（4）我们制定了安全事件应急处理预案，并在发生用户信息安全事件时立即启动应急预案，努力阻止该等安全事件的影响和后果扩大。一旦发生用户信息安全事件（泄露、丢失等）后，我们将按照法律法规的要求，及时将事件相关情况以推送通知等形式告知您，难以逐一告知时，我们会采取合理、有效的方式发布公告。同时，我们还将按照相关监管部门要求，上报用户信息安全事件的处置情况。</span>
        </p>
        <p class="ql-align-justify">
          <strong>1.2</strong>
          <span
            style="color: rgb(56, 56, 56);"
          >尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于互联网环境并非百分之百安全，且因为技术的限制以及可能存在的各种恶意手段，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，</span>
          <strong style="color: rgb(56, 56, 56);">
            <u>我们建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等个人信息透露给他人。</u>
          </strong>
        </p>
        <p class="ql-align-justify">
          <br />
        </p>
        <h4>
          <strong>（五）我们如何使用您的个人信息</strong>
        </h4>
        <p>
          <strong>1.1</strong>
          <span>无悠网络收集的您的个人信息，将被用以向您提供正常服务、无悠网络的服务以及保障您的帐号安全、向您推送展示广告和活动信息等。</span>
        </p>
        <p>
          <strong>1.2</strong>
          <span>为了确保服务的安全，帮助无悠网络更好地了解无悠网络应用程序的运行情况，无悠网络可能记录相关信息，例如，您使用应用程序的频率、崩溃数据、总体使用情况、性能数据以及应用程序的来源。无悠网络不会将存储在分析软件中的信息与您在应用程序中提供的任何个人身份信息相结合。</span>
        </p>
        <p>
          <strong>1.3</strong>
          <span>如无悠网络使用您的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，无悠网络将在使用您的个人信息前，再次向您告知并征得您的明示同意。</span>
        </p>
        <h4>
          <strong>（六）您的权利</strong>
        </h4>
        <h6>
          <strong style="color: rgb(56, 56, 56);">1.1查询个人信息</strong>
        </h6>
        <p class="ql-align-justify">
          <span style="color: rgb(56, 56, 56);">（1）可在点击“头像”图标查询您的账号、ID、昵称、性别、手机号和身份证等信息。</span>
        </p>
        <p class="ql-align-justify">
          <span>（2）查询发布的动态和互动信息。</span>
        </p>
        <h6>
          <strong>1.2删除个人信息</strong>
        </h6>
        <p>
          （1）您
          <span
            style="color: rgb(51, 51, 51);"
          >可以自主通过第三方平台向第三方申请注销账号，注销无悠网络账号以保障无悠网络不再收集您的个人信息。在注销您的账号之前，无悠网络将验证您的个人身份、安全状态、常用设备等信息。您注销账号的行为是不可逆的行为，一旦您注销您的账号，无悠网络将即刻删除或匿名化有关您账户的一切信息，并保证这些信息不会泄露，同时，您也无法通过已注销的账户获得无悠网络的服务。</span>
        </p>
        <p>·&nbsp;如果我们处理个人信息的行为违反法律法规；</p>
        <p>·&nbsp;如果我们收集、使用您的个人信息，却未征得您的同意；</p>
        <p>·&nbsp;如果我们处理个人信息的行为违反了与您的约定。</p>
        <p class="ql-align-justify">
          您可以点击页面下方
          <strong>
            <u>“客服中心”，联系客服</u>
          </strong>基于上述事由请求匿名您的个人信息。
        </p>
        <p class="ql-align-justify">
          <br />
        </p>
        <h6>
          <strong>1.3更正个人信息</strong>
        </h6>
        <p class="ql-align-justify">
          <span>可点击头像图标在“修改密码”中对登陆密码进行修改。</span>
        </p>
        <h6>
          <strong>1.4注销账户的路径</strong>
        </h6>
        <p class="ql-align-justify">
          <span>（1）</span>您
          <span
            style="color: rgb(51, 51, 51);"
          >可以自主通过第三方平台向第三方申请注销账号，注销无悠网络账号以保障无悠网络不再收集您的个人信息。在注销您的账号之前，无悠网络将验证您的个人身份、安全状态、常用设备等信息。您注销账号的行为是不可逆的行为，一旦您注销您的账号，无悠网络将即刻删除或匿名化有关您账户的一切信息，并保证这些信息不会泄露，</span>
          <span
            style="color: rgb(56, 56, 56);"
          >您可以通过以下方式申请注销无悠网络账号，一旦您注销无悠网络账号，将无法使用无悠网络用户产品的服务，因此请您谨慎操作：</span>
        </p>
        <p class="ql-align-justify">
          （2）
          <strong>
            <u>您通过第三方帐号（微信）授权登录无悠网络时，需要向第三方申请注销账号。</u>
          </strong>
        </p>
        <p class="ql-align-justify">
          <br />
        </p>
        <h6>
          <strong>1.5停止运营</strong>
        </h6>
        <p class="ql-align-justify">
          <span>如我们停止运营，将及时停止继续收集您的个人信息的活动，会将停止运营的通知以公告的形式通知您，并对所持有您的个人信息进行删除或匿名化处理。</span>
        </p>
        <h6>
          <strong>1.6响应您的权利请求</strong>
        </h6>
        <p class="ql-align-justify">
          <strong>
            <u>请您理解并同意：对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于需要过多技术手段、付出高额成本或存在其他显著的困难（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险的请求，我们可能会予以拒绝。</u>
          </strong>
        </p>
        <p class="ql-align-justify">在验证您的身份后，无论是否会实现您的请求，我们均会在15日内或法律法规规定的期限内向您回复或做出解释。</p>
        <p class="ql-align-justify">
          <strong>
            <u>请您充分知晓，以下情况可不响应您的查询、删除、更正、撤回授权、注销账户的请求：</u>
          </strong>
        </p>
        <p class="ql-align-justify">（1）与国家安全、国防安全直接相关的；</p>
        <p class="ql-align-justify">（2）与公共安全、公共卫生、重大公共利益直接相关的；</p>
        <p class="ql-align-justify">（3）与犯罪侦查、起诉、审判和执行判决等直接相关的；</p>
        <p class="ql-align-justify">（4）我们有充分证据表明您存在主观恶意或滥用权利的；</p>
        <p class="ql-align-justify">（5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
        <p class="ql-align-justify">（6）涉及商业秘密的。</p>
        <h4>
          <strong style="color: rgb(56, 56, 56);">（七）我们如何保护未成年人的个人信息</strong>
        </h4>
        <p class="ql-align-justify">
          <span>我们非常重视对未成年人个人信息的保护。</span>
          <strong style="color: rgb(56, 56, 56);">
            <u>根据相关法律法规的规定，若您是未满18周岁的未成年人，在使用我们的服务之前，请您让您的父母或监护人阅读本《隐私政策》，并在提交您的个人信息之前获得您监护人的同意和指导。</u>
          </strong>
        </p>
        <p class="ql-align-justify">
          <br />
        </p>
        <h4>
          <strong>（八）本《隐私政策》如何更新</strong>
        </h4>
        <p class="ql-align-justify">
          <span>我们可能修订本《隐私政策》的条款。</span>
        </p>
        <p class="ql-align-justify">
          <span>我们会在本页面发布对本《隐私政策》所做的变更。</span>
          <strong style="color: rgb(56, 56, 56);">
            <u>对于重大变更，我们将在主页显著位置提示或以其他方式通知您。如果您不同意更新后的版本请停止使用无悠网络，如果您继续使用我们的产品/服务，表示您同意接受修订后的本《隐私政策》的约束。</u>
          </strong>
        </p>
        <p class="ql-align-justify">
          <strong>
            <u>“重大变更”是指以下情形之一：</u>
          </strong>
        </p>
        <p class="ql-align-justify">
          <span>（1）我们的核心业务模式发生重大变化。</span>
        </p>
        <p class="ql-align-justify">
          <span style="color: rgb(56, 56, 56);">（2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等。</span>
        </p>
        <p class="ql-align-justify">
          <span>（3）个人信息共享、转让或公开披露的主要对象发生变化。</span>
        </p>
        <p class="ql-align-justify">
          <span>（4）您参与个人信息处理方面的权利及其行使方式发生重大改变。</span>
        </p>
        <p class="ql-align-justify">
          <span style="color: rgb(56, 56, 56);">（5）我们负责受理有关个人信息的投诉、建议和本《隐私政策》联系方式发生变化。</span>
        </p>
        <p class="ql-align-justify">
          <strong>（九）如何联系我们</strong>
        </p>
        <p class="ql-align-justify">
          <span>如您对本《隐私政策》或与本《隐私政策》相关的事宜有任何问题，对我们的服务有任何投诉或建议，请通过以下方式与我们联系：</span>
        </p>
        <p class="ql-align-justify">
          <strong>
            <u>电子邮件：</u>
          </strong>
          <a href="mailto:jilinwuyou_fuwu@163.com；" target="_blank" style="color: rgb(0, 0, 255);">
            <strong>
              <u>jilinwuyou_fuwu@163.com；</u>
            </strong>
          </a>
        </p>
        <p class="ql-align-justify">
          <strong>
            <u>无悠网络公众号：无悠网络</u>
          </strong>
        </p>
        <p class="ql-align-justify">
          <span>一般情况下，我们将在15日内回复。如果您认为我们的个人信息处理行为损害您的合法权益，您还可以向网信部门、工信部门、公安及工商等监管部门进行投诉或举报。</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'YinSiMobile',
  components: {},
  mounted () {
    this.onToTop()
  },
  methods: {
    onToTop () {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    }
  }
}
</script>
